export const ANALYTICS_BETA_FEATURE = 'analytics_beta_feature'
